import React from 'react'
import Banner from '../components/Banner'
import Coinstable from '../Coinstable'

function Homepage() {
  return (
    <>
    <Banner/>
    <Coinstable/>
    </>
  )
}

export default Homepage